// extracted by mini-css-extract-plugin
export var copyableField = "_o6-4";
export var customerBadge = "_o6-0";
export var customerInfoTitle = "_o6-2";
export var details = "_o6-1";
export var dropdownContainer = "_o6-5";
export var dropdownImage = "_o6-6";
export var editAssigneeForm = "_o6-a";
export var editButton = "_o6-3";
export var email = "_o6-7";
export var hidden = "_o6-d";
export var input = "_o6-8";
export var saveButton = "_o6-b";
export var shopifyIcon = "_o6-c";
export var suggestionBadge = "_o6-e";
export var suggestionText = "_o6-f";
export var username = "_o6-9";